import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";
import { militaryBaseGuideEdit_template } from "../components/templates/militaryBaseGuideEdit_template";
import { imagePickerHelper } from "../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { videoPickerHelper } from "../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper";
import { articlePicker_helper } from "./articlePicker_helper";
import { vignettePicker_helper } from "./vignettePicker_helper";
import EmbedHelper from "../utils/EmbedHelper";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = "1.2.0";

let militaryBaseGuideBodyEditor;

/** Ensures CK dialog tweaks match articles_edit_new (single global CKEDITOR.on listener). */
let militaryBaseGuideCkDialogDefsRegistered = false;

export class military_base_guide_edit extends vnModule_knockoutJS {
    public XHRHdl: XMLHttpRequestHandler;
    protected editForm: militaryBaseGuideEdit_template;
    protected XHRHdlCaller: string;
    protected imagePickerHelper: imagePickerHelper;
    protected videoPickerHelper: videoPickerHelper;
    protected articlePickerHelper: articlePicker_helper;
    protected vignettePickerHelper: vignettePicker_helper;
    protected embedHelper: EmbedHelper;
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    protected tagTypeSuggestionXHRHdl: XMLHttpRequestHandler;
    protected datasetSuggestionXHRHdl: XMLHttpRequestHandler;
    protected datasetTagTypeXHRHdl: XMLHttpRequestHandler;
    protected contactSearchXHRHdl: XMLHttpRequestHandler;
    protected contentImageXHRHdl: XMLHttpRequestHandler;
    protected contentVideoXHRHdl: XMLHttpRequestHandler;
    protected imageInContentXHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected refreshContactSearchOnFocus: boolean = false;
    protected contactCreateFocusHandler: any;
    protected embedInsertionRange: any = null;

    constructor(vnAppZone) {
        super(vnAppZone);
        this.embedHelper = new EmbedHelper(this);
    }

    protected getModuleName() {
        return "military_base_guide_edit";
    }

    buildContent(): Array<Element> {
        this.editForm = new militaryBaseGuideEdit_template("editForm", this.viewModel, this);
        this.editForm.setEntityType(this.isHelpService() ? "helpService" : "base");
        this.contactCreateFocusHandler = () => this.onWindowFocusAfterContactCreate();
        window.addEventListener("focus", this.contactCreateFocusHandler);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle(this.isHelpService() ? "Military Help Service Edit" : "Military Base Edit");

        const builtTemplate = this.editForm.build();
        this.setupPickerHelpers();

        return [builtTemplate];
    }

    /**
     * Aligns table/link CKEditor dialogs with articles_edit_new.ts (cell/table insert & properties).
     */
    protected registerCkEditorDialogDefinitions(): void {
        if (typeof CKEDITOR === "undefined" || militaryBaseGuideCkDialogDefsRegistered) {
            return;
        }
        militaryBaseGuideCkDialogDefsRegistered = true;

        CKEDITOR.on("dialogDefinition", function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            if (dialogName == "cellProperties") {
                const cellProps = dialogDefinition.getContents("info");
                cellProps.remove("borderColor");
                cellProps.remove("bgColor");
            }

            if (dialogName == "tableProperties") {
                var infoTab = dialogDefinition.getContents("info");
                infoTab.remove("txtCaption");
                infoTab.remove("txtSummary");
            }

            if (dialogName == "table") {
                var infoTab2 = dialogDefinition.getContents("advanced");
                dialogDefinition.removeContents("advanced");

                var infoTab = dialogDefinition.getContents("info");
                infoTab.remove("cmbAlign");
                infoTab.remove("txtWidth");
                infoTab.remove("txtHeight");
                infoTab.remove("txtCaption");
                infoTab.remove("txtSummary");
            }

            if (dialogName == "link") {
                var targetTab = dialogDefinition.getContents("target");
                var informationTab = dialogDefinition.getContents("info");

                informationTab.remove("browse");

                var targetField = targetTab.get("linkTargetType");
                targetTab.remove("linkTargetType");
                informationTab.add(targetField);
            }
        });
    }

    public fillPage(): void {
        this.getFormData();
    }

    protected getFormData(): void {
        if (this.getEntityId()) {
            this.getEntity();
            return;
        }
        this.getLookups();
    }

    protected getEntity(): void {
        this.loadingIn(this.editForm.builtTemplate);
        let url = this.isHelpService()
            ? "/api/brand/" + this.getBrandId() + "/military-base-guides/help-services/get/" + this.getEntityId() + "/"
            : "/api/brand/" + this.getBrandId() + "/military-base-guides/bases/get/" + this.getEntityId() + "/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({ lockItem: true })]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetEntityReturn;
        this.XHRHdl.execute();
    }

    protected onGetEntityReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.editForm.setLookups(responseParsed.bases || [], responseParsed.helpServiceCategories || [], responseParsed.countries || [], responseParsed.usStates || []);
                obj.editForm.setEntity(obj.isHelpService() ? responseParsed.helpService : responseParsed.base);
                obj.editForm.setLinkedContacts(responseParsed.linkedContacts || []);
                obj.initializeBodyEditor();
                obj.setBodyEditorData(obj.editForm.getTemplateViewModel().body());
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected getLookups(): void {
        this.loadingIn(this.editForm.builtTemplate);
        let url = "/api/brand/" + this.getBrandId() + "/military-base-guides/lookups/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({})]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetLookupsReturn;
        this.XHRHdl.execute();
    }

    protected onGetLookupsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.editForm.setLookups(responseParsed.bases || [], responseParsed.helpServiceCategories || [], responseParsed.countries || [], responseParsed.usStates || []);
                if (obj.isHelpService()) {
                    obj.editForm.setDefaultBase(obj.getDefaultBaseId());
                    obj.editForm.setDefaultCategory(obj.getDefaultCategoryId());
                }
                obj.initializeBodyEditor();
                obj.setBodyEditorData(obj.editForm.getTemplateViewModel().body());
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected saveEntity(): void {
        this.validationTemplate.clearMessages();
        this.loadingIn(this.editForm.builtTemplate);
        this.XHRHdlCaller = "save";
        this.syncBodyEditorToViewModel();

        let url = this.isHelpService()
            ? "/api/brand/" + this.getBrandId() + "/military-base-guides/help-services/save/"
            : "/api/brand/" + this.getBrandId() + "/military-base-guides/bases/save/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.editForm.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveEntityReturn;
        this.XHRHdl.execute();
    }

    protected onSaveEntityReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Military base guide saved successfully.");
                if (obj.getEntityId()) {
                    obj.releaseLock("save");
                } else {
                    obj.redirectAfterSave(JSON.parse(req.request.response).data);
                }
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected releaseLock(actionSource: string): void {
        let url = this.isHelpService()
            ? "/api/brand/" + this.getBrandId() + "/military-base-guides/help-services/release/" + this.getEntityId() + "/"
            : "/api/brand/" + this.getBrandId() + "/military-base-guides/bases/release/" + this.getEntityId() + "/";
        this.XHRHdlCaller = actionSource;
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onReleaseLockReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if (obj.XHRHdlCaller == "save") {
                    page.redirect(obj.buildBaseViewUrl());
                } else {
                    page.redirect(obj.getVnAppZone().app.getLastRoute());
                }
            });
        };
    }

    protected redirectAfterSave(data): void {
        if (this.isHelpService()) {
            const helpService = data.helpService;
            page.redirect("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + helpService.idBase);
        } else {
            const base = data.base;
            page.redirect("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + base.id);
        }
    }

    protected buildBaseViewUrl(): string {
        if (this.isHelpService()) {
            return "/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + this.editForm.getTemplateViewModel().idBase();
        }

        return "/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + this.getEntityId();
    }

    protected cancel(): void {
        if (this.getEntityId()) {
            this.releaseLock("cancel");
            return;
        }
        if (this.isHelpService()) {
            page("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + this.getDefaultBaseId());
        } else {
            page("/brand/" + this.getBrandId() + "/military-base-guides/bases");
        }
    }

    protected isHelpService(): boolean {
        return false;
    }

    public showContactLinker(): void {
        this.editForm.showContactLinker();
        this.searchContacts();
    }

    public hideContactLinker(): void {
        this.editForm.hideContactLinker();
    }

    public searchContacts(): void {
        if (this.contactSearchXHRHdl) {
            this.contactSearchXHRHdl.cancelAndReset();
        }

        this.editForm.setContactSearchLoading(true);
        const url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/get/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.editForm.getContactSearchRequest())]);
        this.contactSearchXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.contactSearchXHRHdl.onReadyStateFunction = this.onSearchContactsReturn;
        this.contactSearchXHRHdl.execute();
    }

    protected onSearchContactsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.editForm.setContactSearchResults(responseParsed.data || []);
            });
            obj.editForm.setContactSearchLoading(false);
        };
    }

    public toggleLinkedContact(contact): void {
        this.editForm.toggleLinkedContact(contact);
    }

    public removeLinkedContact(contact): void {
        this.editForm.removeLinkedContact(contact);
    }

    public openContactViewTab(contact): void {
        if (!contact || !contact.id) {
            return;
        }

        window.open("/brand/" + this.getBrandId() + "/military-base-guides/contacts/view/" + contact.id, "_blank");
    }

    public openContactCreateTab(): void {
        let url = "/brand/" + this.getBrandId() + "/military-base-guides/contacts/add";
        const idBase = this.editForm.getIdBaseForContactCreation();
        if (idBase) {
            url += "/" + idBase;
        }
        this.refreshContactSearchOnFocus = true;
        window.open(url, "_blank");
    }

    protected onWindowFocusAfterContactCreate(): void {
        if (!this.refreshContactSearchOnFocus || !this.editForm || !this.editForm.isContactLinkerVisible()) {
            return;
        }

        this.refreshContactSearchOnFocus = false;
        this.searchContacts();
    }

    public cleanup(): void {
        if (this.contactCreateFocusHandler) {
            window.removeEventListener("focus", this.contactCreateFocusHandler);
        }

        if (typeof CKEDITOR === "undefined") {
            return;
        }

        const editorNames = ["military_base_guide_body", "tag_description", "tag_description_override"];
        editorNames.forEach((name) => {
            if (CKEDITOR.instances && CKEDITOR.instances[name]) {
                CKEDITOR.instances[name].destroy(true);
            }
        });
        militaryBaseGuideBodyEditor = undefined;

        const pluginNames = ["FormatBtn", "InsertDropdown", "AlignDropdown", "blocksCombo", "editMenu", "militarybodywidgets", "selectionWrapCombo"];
        pluginNames.forEach((name) => {
            if (CKEDITOR.plugins && CKEDITOR.plugins.registered && CKEDITOR.plugins.registered[name]) {
                delete CKEDITOR.plugins.registered[name];
            }
        });

        if (CKEDITOR.config && typeof CKEDITOR.config.extraPlugins === "string") {
            CKEDITOR.config.extraPlugins = CKEDITOR.config.extraPlugins
                .split(",")
                .filter((token) => token.trim() !== "militarybodywidgets")
                .join(",");
        }

        if (CKEDITOR.stylesSet && CKEDITOR.stylesSet.registered && CKEDITOR.stylesSet.registered.my_styles) {
            delete CKEDITOR.stylesSet.registered.my_styles;
        }
    }

    protected setupPickerHelpers(): void {
        this.imagePickerHelper = new imagePickerHelper(
            this.editForm.imagePicker,
            this.viewModel,
            this.getVnAppZone(),
            this,
            ["military_base_guide_body"]
        );
        this.videoPickerHelper = new videoPickerHelper(
            this.editForm.videoPicker,
            this.viewModel,
            this.getVnAppZone(),
            this
        );
        this.articlePickerHelper = new articlePicker_helper(
            this.editForm.articlePicker,
            this.getVnAppZone(),
            this
        );
        this.editForm.articlePicker.setIsHyperLinkModeEnabled(true);
        this.editForm.articlePicker.setCaller(this.articlePickerHelper);
        this.vignettePickerHelper = new vignettePicker_helper(
            this.editForm.vignettePicker,
            this.getVnAppZone(),
            this
        );
        this.editForm.vignettePicker.setCaller(this.vignettePickerHelper);
    }

    protected initializeBodyEditor(): void {
        if (typeof CKEDITOR == "undefined") {
            return;
        }
        if (CKEDITOR.instances.military_base_guide_body) {
            CKEDITOR.instances.military_base_guide_body.destroy(true);
        }

        this.registerEditorPlugins();
        this.registerCkEditorDialogDefinitions();
        CKEDITOR.config.skin = "emakiCustomComprehensive";
        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl("contents.css"), "/css/cke_style.css?v=10.8"];
        CKEDITOR.config.extraPlugins = "wordcount,notification,openlink,blocksCombo,codesnippet,horizontalrule,editMenu,FormatBtn,InsertDropdown,justify,AlignDropdown,selectall,militarybodywidgets,selectionWrapCombo";
        CKEDITOR.config.forcePasteAsPlainText = false;
        CKEDITOR.config.wordcount = {
            showParagraphs: false,
            showWordCount: true,
            showCharCount: true,
        };
        // CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;


        CKEDITOR.replace("military_base_guide_body", {
            height: "500px",
            toolbar: "MilitaryBody",
            fillEmptyBlocks: false,
            extraAllowedContent: "span(*)[!data-*,contenteditable]{background-image};img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*];button(*){*}[*];ul(*){*}[*];li(*){*}[*];h2(*){*}[*];h3(*){*}[*];dl(*){*}[*];dt(*){*}[*];dd(*){*}[*];video(*){*}[*];audio(*){*}[*];source(*){*}[*];style[*]{*};hr[*]{*}[*];sub;sup",
            disallowedContent: "p",
            removePlugins: "elementspath,liststyle,image,forms",
            stylesSet: "my_styles",
            format_tags: "p;h1;h2;h3",
            enterMode: CKEDITOR.ENTER_BR,
            format_p: {
                element: "p",
            },
            toolbar_MilitaryBody: [
                ["Undo", "Redo", "EditMenu"],
                ["Blocks", "Bold", "Italic", "Strike", "NumberedList", "BulletedList", "AlignDropdown", "FormatBtn"],
                ["Link", "Unlink", "ImgBtn", "ArticleBtn", "EmbedBtn", "Table", "HorizontalRule", "SpecialChar", "TwoColumnsBtn", "QuickLinksBtn"],
                ["SelectionWrap", "UpdateBtn"],
                ["Source", "Maximize"],
            ],
        });

        militaryBaseGuideBodyEditor = CKEDITOR.instances.military_base_guide_body;
        militaryBaseGuideBodyEditor.on("change", () => {
            this.editForm.getTemplateViewModel().body(militaryBaseGuideBodyEditor.getData());
        });
        this.addOnClickContentHandler([militaryBaseGuideBodyEditor]);
        this.editForm.initTagPickerCkEditors();
    }

    protected addOnClickContentHandler(editors): void {
        const module = this;
        editors.forEach(function (editor) {
            const attachClickHandler = function () {
                const editable = editor.editable();
                if (!editable || editable.$.dataset.militaryBaseGuideClickHandlerAttached == "1") {
                    return;
                }
                editable.$.dataset.militaryBaseGuideClickHandlerAttached = "1";
                editable.attachListener(editable, "click", function (evt) {
                    const target = evt.data.getTarget();
                    module.onClickCkEditorElement(target.$, editor);
                }, null, null, 10);
            };

            editor.on("contentDom", attachClickHandler);
            editor.on("instanceReady", attachClickHandler);
        });
    }

    public onClickCkEditorElement(element, editor): void {
        const editorName = editor.name;

        if (this.isCkEditorWidgetOverlay(element)) {
            return;
        }

        const articleDisplayCard = this.isArticleDisplayCard(element);

        if (articleDisplayCard.isGroupArticle) {
            this.editArticleGroupElement(articleDisplayCard.element, editorName);
            return;
        }

        if (articleDisplayCard.isSingleArticle) {
            this.editForm.editArticleElement(articleDisplayCard.element, editorName);
            return;
        }

        if (element.nodeName == "IMG") {
            let imgSrc = element.getAttribute("src");
            if (imgSrc && imgSrc.includes("?")) {
                imgSrc = imgSrc.split("?")[0];
            }
            this.openBodyImagePickerForEdit();
            this.getImage(imgSrc, element.getAttribute("data-mobile-optimized") || "false");
        }
    }

    protected openBodyImagePickerForEdit(): void {
        this.editForm.prepareImagePickerContext("multi-select", "military_base_guide_body", []);
        this.editForm.imagePicker.show();
        this.editForm.imagePicker.showLoading();

        // Keep page scroll behavior consistent with body-editor tooltip interactions.
        document.body.classList.remove("is-fixed");
    }

    protected isCkEditorWidgetOverlay(element): boolean {
        try {
            const el = element as HTMLElement;
            const isMask = el && el.closest && el.closest(".cke_widget_mask.cke_reset");
            const isDragHandler = el && el.closest && el.closest(".cke_widget_drag_handler.cke_reset");
            return !!(isMask || isDragHandler);
        } catch (e) {
            return false;
        }
    }

    protected registerEditorPlugins(): void {
        if (!CKEDITOR.stylesSet.registered.my_styles) {
        CKEDITOR.stylesSet.add("my_styles", [
            // Block-level styles.
            // { name: "Heading 1", element: "h1" },
            { name: "Heading 2", element: "h2" },
            { name: "Heading 3", element: "h3" },
            { name: "Preformatted", element: "pre" },
            { name: "Quote", element: "blockquote" },
            { name: "Code", element: "code" },
            // Inline styles.
            {
            name: "Related: One link",
            element: "span",
            attributes: { class: "related-single" },
            },
            {
            name: "Next - One link",
            element: "span",
            attributes: { class: "next-single" },
            },
            {
            name: "Affiliate - One link",
            element: "span",
            attributes: { class: "affiliate-single" },
            },
            {
            name: "Spoiler Alert",
            element: "span",
            attributes: { class: "article-alert" },
            },
            {
            name: "Tip",
            element: "div",
            attributes: { class: "emaki-custom tip" },
            },
            {
            name: "Warning",
            element: "div",
            attributes: { class: "emaki-custom warning" },
            },
            {
            name: "Note",
            element: "div",
            attributes: { class: "emaki-custom note" },
            },
            {
            name: "Expandable",
            element: "div",
            attributes: { class: "emaki-custom expandable" },
            },
            {
            name: "Pullquote",
            element: "div",
            attributes: { class: "emaki-custom pullquote" },
            },
            {
            name: "Promoted",
            element: "div",
            attributes: { class: "emaki-custom promoted" },
            },
            {
            name: "Drop Cap",
            element: "div",
            attributes: { class: "emaki-custom paragraph-dropcap" },
            },
            {
            name: "Float Image Left",
            element: "div",
            attributes: { class: "emaki-custom wrap-image" },
            },
            {
            name: "Float Image Right",
            element: "div",
            attributes: { class: "emaki-custom wrap-image-right" },
            },
            {
            name: "Float Badge Left",
            element: "div",
            attributes: { class: "emaki-custom wrap-badge-left" },
            }
        ]);
        }

        if (!CKEDITOR.plugins.registered.FormatBtn) {
            CKEDITOR.plugins.add("FormatBtn", {
                init: function (editor) {
                    editor.ui.addRichCombo("FormatBtn", {
                        label: "Format",
                        title: "Format",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
                        init: function () {
                            this.add("Superscript", "Superscript", "Superscript");
                            this.add("Subscript", "Subscript", "Subscript");
                            this.add("RemoveLink", "Remove Link", "Remove Link");
                            this.add("RemoveFormatting", "Remove Formatting", "Remove Formatting");
                        },
                        onClick: function (value) {
                            editor.focus();
                            const commandMap = {
                                Superscript: "superscript",
                                Subscript: "subscript",
                                RemoveLink: "unlink",
                                RemoveFormatting: "removeFormat",
                            };
                            if (commandMap[value]) {
                                editor.execCommand(commandMap[value]);
                            }
                        },
                    });
                },
            });
        }

        if (!CKEDITOR.plugins.registered.InsertDropdown) {
            CKEDITOR.plugins.add("InsertDropdown", {
                init: function (editor) {
                    editor.ui.addRichCombo("InsertDropdown", {
                        label: "Insert",
                        title: "Insert",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
                        init: function () {
                            this.add("CodeSnippet", "Code Snippet", "Code Snippet");
                            this.add("HorizontalRule", "Horizontal Line", "Horizontal Line");
                            this.add("SpecialChar", "Special Character", "Special Character");
                        },
                        onClick: function (value) {
                            editor.focus();
                            const commandMap = {
                                CodeSnippet: "codeSnippet",
                                HorizontalRule: "horizontalrule",
                                SpecialChar: "specialchar",
                            };
                            if (commandMap[value]) {
                                editor.execCommand(commandMap[value]);
                            }
                        },
                    });
                },
            });
        }

        if (!CKEDITOR.plugins.registered.AlignDropdown) {
            CKEDITOR.plugins.add("AlignDropdown", {
                init: function (editor) {
                    editor.ui.addRichCombo("AlignDropdown", {
                        label: "Align",
                        title: "Align",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
                        init: function () {
                            this.add("JustifyLeft", "Left Align", "Left Align");
                            this.add("JustifyCenter", "Center Align", "Center Align");
                            this.add("JustifyRight", "Right Align", "Right Align");
                            this.add("JustifyBlock", "Justify", "Justify");
                        },
                        onClick: function (value) {
                            editor.focus();
                            const commandMap = {
                                JustifyLeft: "justifyleft",
                                JustifyCenter: "justifycenter",
                                JustifyRight: "justifyright",
                                JustifyBlock: "justifyblock",
                            };
                            if (commandMap[value]) {
                                editor.execCommand(commandMap[value]);
                            }
                        },
                    });
                },
            });
        }

        if (!CKEDITOR.plugins.registered.blocksCombo) {
            CKEDITOR.plugins.add("blocksCombo", {
                init: function (editor) {
                    const blockStyles = {
                        "Heading 2": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "h2" }),
                        "Heading 3": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "h3" }),
                        "Blockquote": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "blockquote" }),
                        "Pullquote": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom pullquote" } }),
                        "Tip - Box": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom tip" } }),
                        "Warning - Box": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom warning" } }),
                        "Note - Box": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom note" } }),
                        "Promoted - Box": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom promoted" } }),
                        "Expandable - See More": new CKEDITOR.style({ type: CKEDITOR.STYLE_BLOCK, element: "div", attributes: { "class": "emaki-custom expandable" } }),
                    };
                    editor.ui.addRichCombo("Blocks", {
                        label: "Block Style",
                        title: "Block Style",
                        toolbar: "styles,10",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
                        init: function () {
                            this.add("Plain", "Plain", "Plain");
                            for (let name in blockStyles) {
                                this.add(name, name, name);
                            }
                        },
                        onClick: function (value) {
                            editor.focus();
                            if (value == "Plain") {
                                editor.execCommand("removeFormat");
                                return;
                            }
                            if (blockStyles[value]) {
                                editor.applyStyle(blockStyles[value]);
                            }
                        },
                    });
                },
            });
        }

        if (!CKEDITOR.plugins.registered.selectionWrapCombo) {
            CKEDITOR.plugins.add('selectionWrapCombo', {
                init: function (editor) {
                    var WRAP_DEFS = [
                        { name: "Heading 2", element: "h2" },
                        { name: "Heading 3", element: "h3" },
                        { name: "Code", element: "code" },
                        { name: "Drop Cap", element: "div", attributes: { "class": "emaki-custom paragraph-dropcap" } },
                        { name: "Block Quote", element: "blockquote" },
                        { name: "Pullquote", element: "div", attributes: { "class": "emaki-custom pullquote" } },
                        { name: "Tip - Box", element: "div", attributes: { "class": "emaki-custom tip" } },
                        { name: "Warning - Box", element: "div", attributes: { "class": "emaki-custom warning" } },
                        { name: "Note - Box", element: "div", attributes: { "class": "emaki-custom note" } },
                        { name: "Promoted - Box", element: "div", attributes: { "class": "emaki-custom promoted" } },
                        { name: "Expandable - See More", element: "div", attributes: { "class": "emaki-custom expandable" } },
                        { name: "Float Image Left", element: "div", attributes: { "class": "emaki-custom wrap-image" } },
                        { name: "Float Image Right", element: "div", attributes: { "class": "emaki-custom wrap-image-right" } },
                        { name: "Float Badge Left", element: "div", attributes: { "class": "emaki-custom wrap-badge-left" } },
                        { name: "Preformatted", element: "pre" },
                        { name: "Spoiler Alert", element: "span", attributes: { "class": "article-alert" } },
                        { name: "Affiliate - Button", element: "span", attributes: { "class": "affiliate-single" } }
                    ];

                    // pre-allow inline span classes for this editor so insertHtml won't be stripped by ACF
                    for (var i = 0; i < WRAP_DEFS.length; i++) {
                        var d = WRAP_DEFS[i];
                        if (d.element === 'span' && d.attributes && d.attributes['class']) {
                            var cls = d.attributes['class'];
                            if (editor.filter && editor.filter.allow) {
                                editor.filter.allow('span(' + cls + ')[*]{*}');
                            } else if (editor.addFeature) {
                                editor.addFeature({ allowedContent: 'span(' + cls + ')[*]{*}' });
                            }
                        }
                    }
                    var DEF_MAP = {}; for (var i = 0; i < WRAP_DEFS.length; i++) DEF_MAP[WRAP_DEFS[i].name] = WRAP_DEFS[i];

                    editor.addCommand('maWrapSelection', {
                        exec: function (ed) {
                            var def = ed._maWrapDef; if (!def) return;

                            var sel = ed.getSelection(); if (!sel) return;
                            var ranges = sel.getRanges(); if (!ranges || !ranges.length) return;
                            var range = ranges[0]; if (range.collapsed) return;   // only when text is selected

                            // 1) Get the selected HTML (no DOM mutation)
                            var selectedHtml = ed.getSelectedHtml && ed.getSelectedHtml(true);
                            if (!selectedHtml) return;

                            // 2) Build wrapper html
                            var tag = String(def.element || 'span').toLowerCase();
                            var attrs = def.attributes || {};
                            var attrStr = '';
                            for (var k in attrs) if (attrs.hasOwnProperty(k)) {
                                // basic escaping
                                attrStr += ' ' + k + '="' + CKEDITOR.tools.htmlEncode(String(attrs[k])) + '"';
                            }
                            var wrapperHtml = '<' + tag + attrStr + '>' + selectedHtml + '</' + tag + '>';

                            // 3) Single editor operation that REPLACES the selection -> single undo step
                            ed.insertHtml(wrapperHtml);
                        }
                    });

                    editor.ui.addRichCombo('SelectionWrap', {
                        label: 'Apply Style',
                        title: 'Apply Style',
                        toolbar: 'styles,20',
                        panel: {
                            css: [CKEDITOR.skin.getPath('editor')].concat(editor.config.contentsCss),
                            multiSelect: false
                        },
                        init: function () {
                            for (var name in DEF_MAP) if (DEF_MAP.hasOwnProperty(name)) this.add(name, name, name);
                        },
                        onClick: function (value) {
                            try { editor.focus(); } catch (_) { }
                            var def = DEF_MAP[value]; if (!def) return;

                            var sel = editor.getSelection();
                            var ranges = sel ? sel.getRanges() : [];
                            if (!ranges || !ranges.length || ranges[0].collapsed) return;

                            var range = ranges[0];
                            var tag = String(def.element || 'span').toLowerCase();
                            var isBlock = !!CKEDITOR.dtd.$block[tag];

                            if (isBlock) {

                                var styleAttrs = def.attributes || {};
                                editor.fire('saveSnapshot'); // begin single undo step

                                // Extract just the selected DOM into a fragment
                                var frag = range.extractContents();

                                // Build the new block and put the fragment inside
                                var newBlock = new CKEDITOR.dom.element(tag, editor.document);
                                for (var k in styleAttrs) if (styleAttrs.hasOwnProperty(k)) newBlock.setAttribute(k, styleAttrs[k]);
                                newBlock.append(frag);

                                // Insert the block back at the caret (now a collapsed range at original position)
                                range.insertNode(newBlock);

                                // Normalize and select the new block
                                var newSelRange = editor.createRange();
                                newSelRange.selectNodeContents(newBlock);
                                sel.selectRanges([newSelRange]);

                                editor.fire('saveSnapshot');
                                return;
                            }

                            // Inline via a command
                            editor._maWrapDef = def;
                            editor.execCommand('maWrapSelection');
                            editor._maWrapDef = null;
                        }
                    });
                }
            });
        }

        if (!CKEDITOR.plugins.registered.editMenu) {
            CKEDITOR.plugins.add("editMenu", {
                init: function (editor) {
                    editor.ui.addRichCombo("EditMenu", {
                        label: "Edit",
                        title: "Edit",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
                        init: function () {
                            this.add("Cut", "Cut", "Cut");
                            this.add("Copy", "Copy", "Copy");
                            this.add("Paste", "Paste", "Paste");
                            this.add("PasteWithoutFormatting", "Paste Without Style", "Paste Without Style");
                            this.add("SelectAll", "Select All", "Select All");
                        },
                        onClick: function (value) {
                            editor.focus();
                            const commandMap = {
                                Cut: "cut",
                                Copy: "copy",
                                Paste: "paste",
                                PasteWithoutFormatting: "pastefromword",
                                SelectAll: "selectAll",
                            };
                            if (commandMap[value]) {
                                editor.execCommand(commandMap[value]);
                            }
                        },
                    });
                },
            });
        }

        if (!CKEDITOR.plugins.registered.militarybodywidgets) {
            const module = this;
            CKEDITOR.plugins.add("militarybodywidgets", {
                init: function (editor) {
                    editor.addCommand("twoColumnsCommand", {
                        exec: function (editor) {
                            module.insertHtmlAtEditor(editor, '<table border="1" cellpadding="1" cellspacing="1"><tbody><tr><td>&nbsp;</td><td>&nbsp;</td></tr></tbody></table>');
                        },
                    });
                    editor.ui.addButton("TwoColumnsBtn", {
                        label: "Two Columns",
                        command: "twoColumnsCommand",
                        toolbar: "insert",
                    });

                    editor.addCommand("imagePickerCommand", {
                        exec: function (editor) {
                            module.editForm.showImagePicker.apply(module.editForm, ["multi-select", editor.name]);
                        },
                    });
                    editor.ui.addButton("ImgBtn", {
                        label: "Insert Images",
                        command: "imagePickerCommand",
                        toolbar: "insert",
                        icon: "/node_modules/ckeditor4/plugins/image2/icons/image.png",
                    });

                    editor.addCommand("articlePickerCommand", {
                        exec: function (editor) {
                            const selection = editor.getSelection();
                            const selectedText = selection && selection.getNative ? selection.getNative().toString() : null;
                            module.editForm.showArticlePicker(editor.name, selectedText);
                        },
                    });
                    editor.ui.addButton("ArticleBtn", {
                        label: "Insert Articles",
                        command: "articlePickerCommand",
                        toolbar: "insert",
                        icon: "/assets/images/article.png",
                    });

                    editor.addCommand("updateBlockCommand", {
                        exec: function (editor) {
                            module.addUpdateBlock(editor);
                        },
                    });
                    editor.ui.addButton("UpdateBtn", {
                        label: "Update",
                        command: "updateBlockCommand",
                        toolbar: "insert",
                    });

                    editor.addCommand("quickLinksCommand", {
                        exec: function (editor) {
                            module.insertHtmlAtEditor(editor, '<div class="emaki-custom quick-links"><h3>Quick Links</h3><ul><li><a href="#">Link text</a></li></ul></div>');
                        },
                    });
                    editor.ui.addButton("QuickLinksBtn", {
                        label: "Quick Links",
                        command: "quickLinksCommand",
                        toolbar: "insert",
                    });

                    editor.addCommand("embedBlockCommand", {
                        exec: function (editor) {
                            module.showEmbedPopUp(editor);
                        },
                    });
                    editor.ui.addButton("EmbedBtn", {
                        label: "Insert Embeds",
                        command: "embedBlockCommand",
                        toolbar: "insert",
                    });

                    module.setupHyperlinkContextMenu(editor);
                },
            });
        }

        if (CKEDITOR.config.extraPlugins.indexOf("militarybodywidgets") === -1) {
            CKEDITOR.config.extraPlugins += ",militarybodywidgets";
        }
    }

    protected addUpdateBlock(editor): void {
        const date = new Date();
        const dformat = [
            date.getFullYear(),
            ("0" + (date.getMonth() + 1)).slice(-2),
            ("0" + date.getDate()).slice(-2),
        ].join("/") + " " + [
            ("0" + date.getHours()).slice(-2),
            ("0" + date.getMinutes()).slice(-2),
        ].join(":") + " EST";
        const authorName = this.getVnAppZone().app.loggedUser.user.valnet_user.fullName;
        this.insertHtmlAtEditor(editor, '<div class="emaki-custom update"><h3>UPDATE: ' + dformat + " BY " + authorName.toUpperCase() + '</h3><strong><em>Title Here..</em></strong><br><br>Text Here..</div>');
    }

    protected insertHtmlAtEditor(editor, html, range = null): void {
        if (range) {
            editor.insertHtml(html, "html", range);
        } else {
            editor.insertHtml(html);
        }
        this.editForm.getTemplateViewModel().body(editor.getData());
    }

    protected setupHyperlinkContextMenu(editor): void {
        const addContextMenu = () => {
            if (!editor.contextMenu || editor._militaryBaseGuideDeleteElementMenuAdded) {
                return;
            }

            if (!editor.getCommand("deleteElement")) {
                editor.addCommand("deleteElement", {
                    exec: function (edt) {
                        const selection = edt.getSelection();
                        const element = selection ? selection.getStartElement() : null;
                        if (element && element.is("span") && element.hasClass("hyperlink")) {
                            const range = new CKEDITOR.dom.range(edt.document);
                            range.setStartBefore(element);
                            range.setEndAfter(element);
                            range.deleteContents();
                            range.insertNode(new CKEDITOR.dom.text(element.getText(), edt.document));
                            selection.selectRanges([range]);
                        }
                    },
                });
            }

            editor.addMenuGroup("deleteGroup");
            editor.addMenuItem("customUnlinkItem", {
                label: "Delete Element",
                command: "deleteElement",
                group: "deleteGroup",
                icon: editor.skinPath + "icons/unlink.png",
            });
            editor.contextMenu.addListener(function (element) {
                if (element && element.is("span") && element.hasClass("hyperlink")) {
                    return { customUnlinkItem: CKEDITOR.TRISTATE_OFF };
                }
            });
            editor._militaryBaseGuideDeleteElementMenuAdded = true;
        };

        if (editor.contextMenu) {
            addContextMenu();
            return;
        }

        editor.on("pluginsLoaded", addContextMenu);
    }

    protected setBodyEditorData(value): void {
        if (militaryBaseGuideBodyEditor) {
            militaryBaseGuideBodyEditor.setData(value || "");
        }
    }

    protected syncBodyEditorToViewModel(): void {
        if (militaryBaseGuideBodyEditor) {
            this.editForm.getTemplateViewModel().body(militaryBaseGuideBodyEditor.getData());
        }
    }

    public getImageData(keyword = null): void {
        if (this.imageXHRHdl) {
            this.imageXHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showLoading();

        const url = "/api/brand/" + this.getBrandId() + "/images/get/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.editForm.imagePicker.getViewModelForRequest())]);

        this.imageXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.imageXHRHdl.execute();
    }

    protected onGetImageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                (<any>obj.imagePickerHelper).updateImagePickerForm(responseParsed);
                obj.editForm.imagePicker.hideLoading();
            });
        };
    }

    public getImagesInContent(target): void {
        if (this.imageInContentXHRHdl) {
            this.imageInContentXHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showInContentLoading();

        const url = "/api/brand/" + this.getBrandId() + "/images/get-in-content/";
        const params: Array<Array<string>> = [];
        params.push(["content", this.getBodyEditor().getData()]);

        this.imageInContentXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.imageInContentXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.imageInContentXHRHdl.onReadyStateFunction = this.onGetInContentImageReturn;
        this.imageInContentXHRHdl.execute();
    }

    protected onGetInContentImageReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.editForm.imagePicker.setImagesInContent(responseParsed.imagesInContent || []);
                obj.editForm.imagePicker.hideInContentLoading();
            });
        };
    }

    protected getImage(imgSrc, isMobileOptimized = "false"): void {
        if (!imgSrc) {
            return;
        }
        if (this.contentImageXHRHdl) {
            this.contentImageXHRHdl.cancelAndReset();
        }

        const url = "/api/brand/" + this.getBrandId() + "/images/get-content-image/";
        const params: Array<Array<string>> = [];
        params.push(["imgSrc", imgSrc]);
        params.push(["isMobileOptimized", isMobileOptimized]);

        this.contentImageXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.contentImageXHRHdl.onReadyStateFunction = this.onImageRequestReturn;
        this.contentImageXHRHdl.execute();
    }

    protected onImageRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                const image = responseParsed.image && responseParsed.image.data ? responseParsed.image.data[0] : null;
                if (!image) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_WARNING,
                        "Could not load clicked image details. You can still choose another image."
                    );
                    return;
                }
                image.isMobileOptimized = responseParsed.isMobileOptimized
                    ? String(responseParsed.isMobileOptimized).toLowerCase() === "true"
                    : false;
                obj.editForm.imagePicker.editImage(image);
            });
            obj.editForm.imagePicker.hideLoading();
        };
    }

    protected insertImage(image, target, extraOption): void {
        if (target == "baseImage") {
            this.editForm.getTemplateViewModel().baseImage(image);
            return;
        }
        if (target == "images") {
            return;
        }

        this.insertHtmlAtEditor(this.getBodyEditor(), this.buildImageTag(image, false, extraOption));
    }

    protected insertImages(images, target, extraOption): void {
        if (target == "images") {
            this.editForm.getTemplateViewModel().images((images || []).slice());
            return;
        }

        this.insertHtmlAtEditor(this.getBodyEditor(), this.buildImageGroupTag(images, extraOption));
    }

    protected insertGallery(gallery, target, extraOption): void {
        if (target == "images") {
            return;
        }
        this.insertHtmlAtEditor(this.getBodyEditor(), this.buildGalleryTag(gallery, extraOption));
    }

    public onClickInsertImageGroupTag(images, target, markup): void {
        if (target == "images") {
            this.editForm.getTemplateViewModel().images((images || []).slice());
        }
    }

    public getVideoReferences(): void {
        this.videoPickerHelper.getVideoReferences();
    }

    public getVideosData(): void {
        this.videoPickerHelper.getVideosData();
    }

    public showVideoPicker(target): void {
        this.videoPickerHelper.setTarget(target);
        this.videoPickerHelper.showVideoPicker();
        this.videoPickerHelper.getVideoReferences();
        this.videoPickerHelper.getVideosData();
    }

    protected getVideo(videoId): void {
        if (!videoId) {
            return;
        }
        if (this.contentVideoXHRHdl) {
            this.contentVideoXHRHdl.cancelAndReset();
        }

        const url = "/api/brand/" + this.getBrandId() + "/videos/get-content-video/";
        const params: Array<Array<string>> = [];
        params.push(["videoId", videoId]);

        this.contentVideoXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.contentVideoXHRHdl.onReadyStateFunction = this.onVideoRequestReturn;
        this.contentVideoXHRHdl.execute();
    }

    protected onVideoRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.videoPickerHelper.editVideo(responseParsed.video);
            });
        };
    }

    protected getUploadUrlSubtitles(): string {
        return "/api/brand/" + this.getBrandId() + "/videos/subtitles/upload";
    }

    public insertVideo(param?, target?, data?): void {
        if (target && target.element) {
            const element = target.element;
            if (element.parentElement) {
                element.parentElement.removeChild(element);
            }
            target = target.editor;
        }
        this.insertHtmlAtEditor(this.getBodyEditor(), this.buildVideoHTMLTag(data));
        this.videoPickerHelper.hideVideoPicker();
    }

    protected showTagPicker(editor): void {
        this.editForm.tagPicker.resetPagination();
        this.getTagData();
        const selection = editor && editor.getSelection && editor.getSelection();
        const selectedText = selection && selection.getNative ? selection.getNative().toString() : null;
        this.editForm.showTagPicker("in-content", editor.name, selectedText);
    }

    protected showEmbedPopUp(editor): void {
        this.editForm.setActiveCkEditorInstance(editor);
        this.embedInsertionRange = this.getEditorInsertionRange(editor);
        this.editForm.toggleEmbedPopUp(true);
        this.editForm.setEmbedSourceFocused(true);
    }

    protected getEditorInsertionRange(editor): any {
        try {
            const selection = editor && editor.getSelection ? editor.getSelection() : null;
            const ranges = selection ? selection.getRanges() : [];
            if (ranges && ranges.length > 0) {
                return ranges[0].clone();
            }

            const range = editor.createRange();
            range.moveToElementEditEnd(range.root);
            return range;
        } catch (e) {
            return null;
        }
    }

    public generateEmbed(source, embedContext = null): void {
        this.loadingIn(this.editForm.builtTemplate);
        this.embedHelper.generateEmbed(
            source,
            this.editForm.getTemplateViewModel().embedType(),
            embedContext
        );
    }

    public onGenerateEmbedRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState != 4) {
                return;
            }

            const responseParsed = JSON.parse(req.request.response);
            if (req.request.status == 200) {
                obj.editForm.setEmbedData(responseParsed.data);
            } else {
                obj.editForm.setEmbedErrors(responseParsed);
            }

            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    public addEmbedCodeToCkEditor(value): void {
        const editor = this.editForm.getActiveCkEditorInstance() || this.getBodyEditor();
        const range = this.embedInsertionRange || this.getEditorInsertionRange(editor);
        this.insertHtmlAtEditor(editor, "<br />" + value + "<br /> &nbsp;", range);
        this.embedInsertionRange = null;
        this.editForm.toggleEmbedPopUp(false);
        this.editForm.resetEmbedPopUp();
    }

    protected paginationOnPageClick(): void {
        this.getTagData();
    }

    protected filterSimpleOnChange(idElement?): void {
        this.getTagData();
    }

    protected filterSimpleCancel(): void {
        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }
    }

    public getSuggestions(keyword, idSourceElement): void {
        if (idSourceElement == "filterTagType") {
            this.getTagTypesSuggestion(keyword);
        }
    }

    protected getTagTypesSuggestion(keyword): void {
        if (this.tagTypeSuggestionXHRHdl) {
            this.tagTypeSuggestionXHRHdl.cancelAndReset();
        }

        const subViewModel = {
            filter: {
                keyword: keyword,
                limit: 25,
            },
        };
        const url = "/api/brand/" + this.getBrandId() + "/search/tag/type/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subViewModel)]);
        this.tagTypeSuggestionXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.tagTypeSuggestionXHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.tagTypeSuggestionXHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                const tagTypes = responseParsed.data && responseParsed.data.tagTypes ? responseParsed.data.tagTypes : [];
                obj.editForm.tagPicker.setTagTypeOptions(tagTypes);
            });
        };
    }

    public getDatasetSuggestion(keyword): void {
        if (this.datasetSuggestionXHRHdl) {
            this.datasetSuggestionXHRHdl.cancelAndReset();
        }

        const subViewModel = {
            keyword: keyword,
            limit: null,
            restrictOwnedTagTypes: false,
        };
        const url = "/api/brand/" + this.getBrandId() + "/search/tag/dataset/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subViewModel)]);
        this.datasetSuggestionXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.datasetSuggestionXHRHdl.onReadyStateFunction = this.onGetDatasetSuggestionReturn;
        this.datasetSuggestionXHRHdl.execute();
    }

    protected onGetDatasetSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                const datasets = responseParsed.data && responseParsed.data.templateTypes ? responseParsed.data.templateTypes : [];
                obj.editForm.tagPicker.setDatasetFilter(datasets);
            });
        };
    }

    public getTagTypeByDatasetId(idDataset): void {
        if (this.datasetTagTypeXHRHdl) {
            this.datasetTagTypeXHRHdl.cancelAndReset();
        }

        const subViewModel = {
            idDataset: idDataset,
        };
        const url = "/api/brand/" + this.getBrandId() + "/search/tag/types/get_by_dataset_id/" + idDataset + "/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subViewModel)]);
        this.datasetTagTypeXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.datasetTagTypeXHRHdl.onReadyStateFunction = this.onGetTagTypeByDatasetIdReturn;
        this.datasetTagTypeXHRHdl.execute();
    }

    protected onGetTagTypeByDatasetIdReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.editForm.tagPicker.setTagTypeDropdown(responseParsed.data || []);
            });
        };
    }

    public deleteAllSelectedTagType(): void {
        this.editForm.tagPicker.deleteAllSelectedTagType();
    }

    protected onAutocompleteOptionChange(idElement): void {
        if (idElement == "filterTagType") {
            this.editForm.tagPicker.onAddTagTypeFilter();
        }
    }

    protected onAutocompleteInputClear(idElement): void {
        if (idElement == "filterTagType") {
            this.editForm.tagPicker.deleteAllSelectedTagType();
        }
    }

    protected onAutocompleteInputClick(idElement): void {}

    protected onAutocompleteAddNewSelected(idElement): void {}

    protected onAutocompleteAddNewInputChange(idElement?): void {}

    protected onAutocompleteAddNewInputClick(idElement): void {}

    protected onAutocompleteAcceptSuggestion(idElement): void {}

    protected getTagData(): void {
        if (this.tagSearchXHRHdl) {
            this.tagSearchXHRHdl.cancelAndReset();
        }
        this.editForm.tagPicker.showLoading();
        const url = "/api/brand/" + this.getBrandId() + "/tags/get/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.editForm.tagPicker.getViewModelForRequest())]);
        this.tagSearchXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.tagSearchXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagSearchXHRHdl.onReadyStateFunction = this.onGetTagDataReturn;
        this.tagSearchXHRHdl.execute();
    }

    protected onGetTagDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateTagPickerForm(responseParsed);
            });
            obj.editForm.tagPicker.hideLoading();
        };
    }

    protected updateTagPickerForm(responseParsed): void {
        const selectedTags = this.editForm.tagPicker.getSelectedTags();

        if (responseParsed.data) {
            for (let tag of responseParsed.data) {
                tag.selected = false;
                const selectedTag = selectedTags.find((selected) => selected.id == tag.id);
                if (selectedTag) {
                    tag.selected = true;
                }
            }
            this.editForm.tagPicker.setTagResults(responseParsed.data);
            this.editForm.tagPicker.setTagsPagination(responseParsed.totalPage || 1, responseParsed.currentPage || 1);
        } else {
            this.editForm.tagPicker.setTagResults([]);
            this.editForm.tagPicker.setTagsPagination(1, 1);
        }
    }

    public getTag(tag, select = false): void {
        this.getTags([tag], select);
    }

    protected getTags(idTags, select = false): void {
        if (this.tagXHRHdl) {
            this.tagXHRHdl.cancelAndReset();
        }
        this.XHRHdlCaller = select ? "tag_picker_select" : "tag_picker_view";
        const url = "/api/brand/" + this.getBrandId() + "/tag-picker/tags/get/";
        const params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({ idTags: idTags })]);
        this.tagXHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.tagXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.tagXHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
        this.tagXHRHdl.execute();
    }

    protected onGetTagRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                const tagResponse = responseParsed.tags && responseParsed.tags[0] ? responseParsed.tags[0] : null;
                if (!tagResponse || !tagResponse.tag) {
                    return;
                }
                const tag = tagResponse.tag;
                tag.specsValues = tagResponse.specsValues;
                tag.specDefaults = tagResponse.specDefaults;
                tag.includeCommunityRating = tagResponse.includeCommunityRating ? tagResponse.includeCommunityRating : false;
                tag.communityRating = tagResponse.communityRating ? tagResponse.communityRating : { average: null, count: 0 };
                if (obj.XHRHdlCaller == "tag_picker_select") {
                    obj.editForm.tagPicker.selectTag({ ...tag, pros: [], cons: [] }, true);
                } else {
                    obj.editForm.tagPicker.setTag({ ...tag, pros: [], cons: [] });
                    obj.editForm.tagPicker.setGroupings(tagResponse.groupings);
                }
            });
            obj.editForm.tagPicker.hideViewLoading();
            obj.editForm.tagPicker.hideLoading();
        };
    }

    protected editTagElement(element, editor): void {
        const tagInsertedFields = this.editForm.getTagElementInsertedFieldsInOrder(element);
        this.editForm.setTagGroupTagElements([tagInsertedFields]);
        this.getTag(tagInsertedFields.id);
        this.editForm.editTagElement(element, editor);
    }

    protected editTagGroupElement(element, editor): void {
        const tagIds = [];
        const tagGroupFieldsInserted = [];
        for (let child of element.childNodes) {
            if (
                child.nodeName == "DIV" &&
                child.classList.contains("emaki-displayCard") &&
                child.classList.contains("tag")
            ) {
                tagGroupFieldsInserted.push(this.editForm.getTagElementInsertedFieldsInOrder(child));
                tagIds.push(child.getAttribute("data-id"));
            }
        }

        this.editForm.setTagGroupTagElements(tagGroupFieldsInserted);

        if (tagIds.length == 1) {
            this.getTags(tagIds);
            this.editForm.editTagElement(element, editor);
            return;
        }

        if (tagIds.length > 1) {
            this.getTags(tagIds);
            this.editForm.editTagGroup(element, editor);
        }
    }

    public setTagEditLock(tag): void {
        this.getTag(tag.id);
    }

    public releaseBrandTagLock(idTag): void {
        this.editForm.tagPicker.hideEdit();
    }

    protected saveTag(saveData): void {
        this.editForm.tagPicker.hideEdit();
        this.getTagData();
    }

    protected insertTagElement(elementToReplace, element, target): void {
        if (elementToReplace && elementToReplace.parentElement) {
            elementToReplace.parentElement.removeChild(elementToReplace);
        }
        const editor = this.getEditor(target);

        if (!editor) {
            return;
        }

        const range = this.getEditorInsertionRange(editor);
        this.insertHtmlAtEditor(editor, element, range);
    }

    protected insertTagHyperlinkElement(elementToReplace, element, target): void {
        this.insertTagElement(elementToReplace, element, target);
    }

    protected insertArticleElement(elementToReplace, elementHtml, target): void {
        if (elementToReplace && elementToReplace.parentElement) {
            elementToReplace.parentElement.removeChild(elementToReplace);
        }
        this.insertHtmlAtEditor(this.getBodyEditor(), elementHtml);
    }

    protected editArticleGroupElement(element, target): void {
        const articleIds = [];
        const articleGroupFieldsInserted = [];
        for (let child of element.childNodes) {
            if (
                child.nodeName == "DIV" &&
                child.classList.contains("emaki-displayCard") &&
                child.classList.contains("article")
            ) {
                articleGroupFieldsInserted.push(this.editForm.getArticleElementInsertedFieldsInOrder(child));
                articleIds.push(child.getAttribute("data-id"));
            }
        }

        this.editForm.setArticleGroupArticleElements(articleGroupFieldsInserted);

        if (articleIds.length >= 1) {
            this.editForm.editArticleGroup(element, target);
            this.articlePickerHelper.getArticlesByIds(articleIds);
        }
    }

    protected insertVignetteElement(elementToReplace, element, target): void {
        if (elementToReplace && elementToReplace.parentElement) {
            elementToReplace.parentElement.removeChild(elementToReplace);
        }
        this.insertHtmlAtEditor(this.getBodyEditor(), element);
    }

    protected editVideoCardElement(element, editorName): void {
        const videoId = element.dataset.id;
        this.showVideoPicker(editorName);
        this.getVideo(videoId);
        this.videoPickerHelper.setVideoCardElement(element);
    }

    public replaceOrUpdateVideoCardElement(oldVideoElement, newVideoData, target): void {
        const editor = this.getBodyEditor();
        const oldVideoElementId = oldVideoElement.dataset.id;
        const oldElement = editor.editable().findOne('*[data-id="' + oldVideoElementId + '"]');
        if (oldElement) {
            oldElement.remove();
        }
        this.insertHtmlAtEditor(editor, this.buildVideoHTMLTag(newVideoData));
    }

    protected getBodyEditor() {
        return militaryBaseGuideBodyEditor;
    }

    protected getEditor(target) {
        if (target && target.name) {
            return target;
        }

        if (target && target.editor) {
            target = target.editor;
        }

        switch (target) {
            case "military_base_guide_body":
                return militaryBaseGuideBodyEditor;
            default:
                return this.getBodyEditor();
        }
    }

    protected isTagDisplayCard(element) {
        const originalElement = element;
        const elementInfo = {
            isVideoCard: false,
            isSingleTag: false,
            isHyperlink: false,
            isGroupTag: false,
            element: originalElement,
        };

        while (element) {
            if (
                element.classList &&
                element.classList.contains("emaki-displayCard") &&
                element.classList.contains("tag")
            ) {
                elementInfo.isSingleTag = true;
                elementInfo.element = element;
                if (
                    element.parentNode &&
                    element.parentNode.nodeName == "DIV" &&
                    element.parentNode.classList.contains("emaki-displayCard-group")
                ) {
                    elementInfo.isSingleTag = false;
                    elementInfo.isGroupTag = true;
                    elementInfo.element = element.parentNode;
                    break;
                }
            }

            if (
                element.nodeName == "DIV" &&
                element.classList.contains("emaki-displayCard") &&
                element.classList.contains("video")
            ) {
                elementInfo.isVideoCard = true;
                elementInfo.element = element;
            }

            if (
                element.nodeName == "SPAN" &&
                element.classList.contains("emaki-displayCard") &&
                element.classList.contains("hyperlink")
            ) {
                elementInfo.isSingleTag = true;
                elementInfo.isHyperlink = true;
                elementInfo.element = element;
            }

            element = element.parentNode;
        }

        return elementInfo;
    }

    protected isArticleDisplayCard(element) {
        const originalElement = element;
        const elementInfo = {
            isSingleArticle: false,
            isGroupArticle: false,
            isHyperlink: false,
            element: originalElement,
        };

        while (element) {
            if (
                element.nodeName == "DIV" &&
                element.classList.contains("emaki-displayCard") &&
                element.classList.contains("article")
            ) {
                elementInfo.isSingleArticle = true;
                elementInfo.element = element;
                if (
                    element.parentNode &&
                    element.parentNode.nodeName == "DIV" &&
                    element.parentNode.classList.contains("emaki-displayCard-group") &&
                    element.parentNode.classList.contains("article")
                ) {
                    elementInfo.isSingleArticle = false;
                    elementInfo.isGroupArticle = true;
                    elementInfo.element = element.parentNode;
                }
                break;
            }

            if (
                (element.nodeName == "SPAN" &&
                    element.classList.contains("emaki-displayCard") &&
                    element.classList.contains("hyperlink-article") &&
                    element.classList.contains("hyperlink")) ||
                (element.classList && element.classList.contains("emaki-article-card"))
            ) {
                elementInfo.isSingleArticle = true;
                elementInfo.isHyperlink = true;
                elementInfo.element = element;
                break;
            }

            element = element.parentNode;
        }

        return elementInfo;
    }

    protected isVignetteDisplayCard(element) {
        const originalElement = element;
        const elementInfo = {
            isVignetteDisplayCard: false,
            element: originalElement,
        };

        while (element) {
            if (
                element.nodeName == "DIV" &&
                element.classList.contains("emaki-displayCard") &&
                element.classList.contains("vignette")
            ) {
                elementInfo.isVignetteDisplayCard = true;
                elementInfo.element = element;
                break;
            }

            element = element.parentNode;
        }

        return elementInfo;
    }

    protected buildImageGroupTag(images, extraOption): string {
        let imageGroupTag = '<div class="' + ("emaki-imgGroup " + (extraOption || "")).trim() + '">';
        images.forEach((image) => imageGroupTag += this.buildImageTag(image, false, ""));
        return imageGroupTag + "</div>";
    }

    protected buildGalleryTag(gallery, extraOption): string {
        let galleryTag = '<div class="' + ("emaki-imgGroup emaki-group " + (extraOption || "")).trim() + '" gallery-id="' + gallery.id + '">';
        (gallery.images || []).slice(0, 5).forEach((image) => galleryTag += this.buildImageTag(image, false, ""));
        return galleryTag + "</div>";
    }

    protected buildImageTag(image, addCaption, extraOption): string {
        const altText = image.altText ? String(image.altText).replace(/"/g, "&quot;") : "";
        let imgTag = '<img data-image-id="' + image.id + '" src="' + image.url + '" alt="' + altText + '" width="' + image.width + '" height="' + image.height + '" />';
        if (addCaption && image.caption) {
            imgTag = "[caption]" + imgTag + " " + image.caption + "[/caption]";
        }
        return extraOption ? '<div class="emaki-imgGroup emaki-imgSingle grid_view">' + imgTag + "</div>" : imgTag;
    }

    protected buildVideoHTMLTag(video): string {
        const thumbnailUrl = video && video.thumbnail ? video.thumbnail.url : "/assets/images/replace-video.png";
        return '<div class="emaki-displayCard video" data-id="' + video.id + '"><div class="w-video-info"><h3 class="video-title" data-field="title">' + (video.title || "") + '</h3><div class="w-img" style="width: auto; height: auto"><img data-field="video" src="' + thumbnailUrl + '" width="400" height="224" alt="" data-video-url="' + (video.url || "") + '" data-video-title="' + (video.title || "") + '"></div></div></div>';
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    public getIdBrand(): number {
        return this.getBrandId();
    }

    protected getEntityId(): number {
        return Number(this.getVnAppZone().app.params.id || 0);
    }

    protected getDefaultBaseId(): number {
        return Number(this.getVnAppZone().app.params.idBase || 0);
    }

    protected getDefaultCategoryId(): number {
        return Number(this.getVnAppZone().app.params.idCategory || 0);
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_base_guide_edit.ts